import { render, staticRenderFns } from "./teacherEvaluatio-1.vue?vue&type=template&id=53797e64"
import script from "./teacherEvaluatio-1.vue?vue&type=script&lang=js"
export * from "./teacherEvaluatio-1.vue?vue&type=script&lang=js"
import style0 from "./teacherEvaluatio-1.vue?vue&type=style&index=0&id=53797e64&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports